import { Interval, isWithinInterval } from 'date-fns';

export const INVITE_EVENT_PERIOD = {
  start: '2024-08-12T00:00:00+09:00',
  end: '9999-12-31T23:59:59+09:00'
};

export const isInviteEventProceeding = isWithinInterval(new Date(), {
  start: new Date(INVITE_EVENT_PERIOD.start),
  end: new Date(INVITE_EVENT_PERIOD.end)
} as Interval);

export const INVITE_EVENT_PROMOTION_CODE = 'INVITATION_NAVER_PAY_POINT';
export const INVITE_EVENT_SESSION_STORAGE_KEY = 'invitePromotionData';

export const VIDEO_TYPE: Record<string, string> = {
  mp4: 'video/mp4',
  webm: 'video/webm',
  ogg: 'video/ogg'
};
